module.exports = __webpack_public_path__ + "img/DiHS_Video_Icon_Lu_Ton4.00176c45.png";